<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-11-05 18:43:16
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-12-02 10:24:35
 * @FilePath: /qd-ibms-web/src/views/alarm-list/index.vue
 * @Description: 这是默认设置,请设置`customMade`,
-->
<template>
  <section
    ref="pageMainRef"
    class="page-container__report backdrop"
    :class="props.activeName === 1? 'no-padding' : ''"
  >
    <section class="page__search-form">
      <lf-screen-form
        ref="formRef"
        :model="searchParams"
        label-size="default"
      >
        <lf-screen-form-item
          label="告警源"
          prop="alarmSource"
        >
          <el-input
            v-model="searchParams.alarmSource"
            placeholder="请输入告警源"
            clearable
          />
        </lf-screen-form-item>
        <lf-screen-form-item
          label="告警类型"
          prop="bizSource"
        >
          <el-select
            v-model="searchParams.bizSource"
            clearable
            filterable
            placeholder="请选择类型名称"
            @change="getAlarmFiltersData"
          >
            <el-option
              v-for="item of bizSourceOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </lf-screen-form-item>
        <lf-screen-form-item
          label="告警规则"
          prop="alarmRuleCode"
        >
          <el-select
            v-model="searchParams.alarmRuleCode"
            clearable
            filterable
            placeholder="请选择告警规则"
          >
            <el-option
              v-for="item of alarmRuleCodeOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </lf-screen-form-item>
        <lf-screen-form-item
          label="告警级别"
          prop="alarmLevel"
        >
          <el-select
            v-model="searchParams.alarmLevel"
            clearable
            filterable
            multiple
            collapse-tags
            placeholder="请选择告警级别"
          >
            <el-option
              v-for="item of alarmLevelOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </lf-screen-form-item>
        <lf-screen-form-item
          label="设备类型"
          prop="deviceTypeCode"
        >
          <el-select
            v-model="searchParams.deviceTypeCode"
            clearable
            multiple
            filterable
            collapse-tags
            placeholder="请选择设备类型"
          >
            <el-option
              v-for="item of deviceTypeOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </lf-screen-form-item>
        <lf-screen-form-item
          label="工单发送状态"
          prop="processStatus"
        >
          <el-select
            v-model="searchParams.processStatus"
            clearable
            placeholder="请选择工单发送状态"
          >
            <el-option
              v-for="item of processStatusOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </lf-screen-form-item>

        <lf-screen-form-item
          label="时间选择"
          prop="timeRange"
        >
          <el-date-picker
            v-model="timeRange"
            type="datetimerange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            range-separator="至"
            popper-class="clear-btn"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :default-time="defaultTime2"
            @change="handleTimeRangeChange"
          />
        </lf-screen-form-item>
        <template v-slot:buttons>
          <el-button
            type="primary"
            @click="handleCurrentChange(1)"
          >
            查询
          </el-button>
          <el-button @click="handleReset">重置</el-button>
        </template>
      </lf-screen-form>
    </section>

    <section class="page__search-result mt-8">
      <lf-report-operate>
        <template #title>
          <p class="custom-title">
            {{ title }}
          </p>
        </template>
        <template
          #actions
          v-if="props.activeName!==3"
        >
          <!-- <base-download-button
            label="导出"
            :download-name="`${title}.xlsx`"
            type="primary"
            method="post"
            :res-type="2"
            blob-type="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
            :request="alarmExportUrl"
            :query-params="getQueryParams()"
          /> -->
          <base-download-button
            label="导出"
            type="primary"
            method="post"
            is-async
            :request="alarmExportUrl"
            :query-params="getQueryParams(true)"
          />
        </template>
      </lf-report-operate>

      <el-table
        v-loading="loading"
        class="mt-12"
        :max-height="tableMaxHeight"
        :data="tableData"
        border
      >
        <el-table-column
          show-overflow-tooltip
          prop="orgName"
          label="项目名称"
          min-width="120"
        />
        <el-table-column
          show-overflow-tooltip
          prop="bizSourceDesc"
          label="告警类型"
          min-width="80"
        />
        <el-table-column
          prop="alarmSource"
          label="告警源"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column
          show-overflow-tooltip
          prop="alarmTimestamp"
          label="告警时间"
          min-width="150"
        >
          <template v-slot="scope">
            {{ scope.row.alarmTimestamp ? formatDate(scope.row.alarmTimestamp) : '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="alarmDesc"
          label="告警描述"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column
          prop="alarmLevelDesc"
          label="告警级别"
        >
          <template v-slot="scope">
            <span
              :class="{
                danger: scope.row.alarmLevel === 3,
                warning: scope.row.alarmLevel === 2,
              }"
            >
              {{ scope.row.alarmLevelDesc }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="processStatus"
          label="工单发送状态"
        >
          <template v-slot="scope">
            {{ statusToTxt(scope.row.processStatus) || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="alarmValue"
          label="告警值"
          min-width="80"
        />
        <el-table-column
          v-if="props.activeName===3"
          prop="alarmSuppressedCount"
          label="告警压制数量"
          min-width="120"
        >
          <template v-slot="scope">
            <span
              class="sup-count"
              @click="handleSuppression(scope.row)"
            >
              {{ scope.row.alarmSuppressedCount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="160"
          fixed="right"
        >
          <template v-slot="scope">
            <el-button
              link
              type="primary"
              @click="handleDetail(scope.row)"
            >
              详情
            </el-button>
            <el-button
              v-if="props.activeName===1"
              v-permission="['REAL_TIME_ALARM_VIDEO']"
              link
              :disabled="!scope.row.spaceCode || !scope.row.confCamera"
              type="primary"
              @click="openVideo(scope.row)"
            >
              查看视频
            </el-button>
            <el-button
              v-if="props.activeName===1"
              v-permission="['REAL_TIME_ALARM_E']"
              link
              type="primary"
              @click="handleQuarantine(scope.row,1)"
            >
              隔离
            </el-button>
            <el-button
              v-if="props.activeName===3"
              link
              type="primary"
              @click="handleQuarantine(scope.row,2)"
            >
              隔离详情
            </el-button>
            <el-button
              v-if="props.activeName===3"
              v-permission="['QUARANTINE_ALARM_U']"
              link
              type="primary"
              @click="recover(scope.row)"
            >
              解除隔离
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <base-pagination
        :page-num="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </section>
    <lf-base-dialog
      v-if="suppressionDialog"
      v-model="suppressionDialog"
      title="告警压制数量详情"
      size="large"
      :append-to-body="true"
      class="el-dialog--maia ib-form default"
      @close="suppressionDialog = false"
    >
      <div class="maia-content">
        <el-table
          v-loading="dialogLoading"
          :data="suppressionData"
          border
          class="is-grey"
          max-height="500"
        >
          <el-table-column
            show-overflow-tooltip
            prop="alarmTimestamp"
            label="告警时间"
            min-width="90"
          >
            <template v-slot="scope">
              {{ scope.row.alarmTimestamp ? formatDate(scope.row.alarmTimestamp) : '-' }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="alarmLevelDesc"
            label="告警级别"
            min-width="90"
          />
          <el-table-column
            show-overflow-tooltip
            prop="alarmValue"
            label="告警值"
            min-width="90"
          />
          <el-table-column
            show-overflow-tooltip
            prop="alarmSource"
            label="告警源"
            min-width="90"
          />
          <el-table-column
            show-overflow-tooltip
            prop="alarmDesc"
            label="告警信息"
            min-width="90"
          />
          <el-table-column
            show-overflow-tooltip
            prop="srcState"
            label="告警源状态"
            min-width="90"
          >
            <template v-slot="scope">
              {{ scope.row.srcState==='alarm'?'异常':"正常" }}
            </template>
          </el-table-column>
        </el-table>

        <base-pagination
          :page-num="suppressionPagination.pageNum"
          :page-size="suppressionPagination.pageSize"
          :total="suppressionPagination.total"
          @size-change="spHandleSizeChange"
          @current-change="spHandleCurrentChange"
        />
      </div>

      <template v-slot:footer>
        <span>
          <el-button
            size="small"
            @click="suppressionDialog = false"
          >
            关闭
          </el-button>
        </span>
      </template>
    </lf-base-dialog>
    <!-- 详情 -->
    <lf-base-dialog
      v-if="state.showDetailModal"
      v-model="state.showDetailModal"
      title="详情"
      size="large"
      :append-to-body="true"
      class="el-dialog--maia ib-form default"
      @close="state.showDetailModal = false"
    >
      <detail
        :data="state.detailData"
        :flag="props.activeName"
      />
      <template v-slot:footer>
        <span>
          <el-button
            size="small"
            @click="state.showDetailModal = false"
          >
            关闭
          </el-button>
        </span>
      </template>
    </lf-base-dialog>
    <isolation
      v-if="showIsolationModal"
      :detail="state.currentAlarmDetailData"
      :isoationstatus="isoationstatus"
      :is-visible="showIsolationModal"
      @close="showIsolationModal = false"
      @search="searchData"
    />
    <!-- 隔离详情和隔离操作 -->
  </section>
  <view-video ref="viewVideoRef" />
</template>
  <script setup lang="ts">
  import {
    ref, reactive, watch, computed,
    onMounted,
    nextTick,
    onUnmounted,
  } from 'vue';
  import { useElementSize } from '@vueuse/core';
  import { useOrgStore } from '@/store/org';
  import { ElMessage, ElMessageBox } from 'element-plus';
  import {
    getAlarmList, getAlarmFilters, alarmExportUrl, isolateRecover, alarmSuppressionList, alarmDetail,
  } from '@/api/modules/alarm';
  import { formatDate } from '@/utils/index';
  import viewVideo from '@/views/ibms/components/view-video.vue';
  import { useRoute } from 'vue-router';
  import Detail from './detail.vue';
  import isolation from './isolation.vue';
  import {
    PROCESS_OPTIONS, ALARM_LEVEL_OPTIONS, BIZ_SOURCE_OPTIONS, TITLE_LIST,
  } from './constants';

  const {
    VITE_APP_MODEL_SHOW: modelVisible,
  } = import.meta.env;

  interface ProjectItem {
    name: string
    showTime: string
    time: number | null
  }

  const props = defineProps({
    activeName: {
      type: Number,
      default: 1,
    },
    queryParams: {
      type: Object,
      default: () => ({}),
    },
    time: {
      type: Array,
      default: () => ([]),
    },
  });

  const emit = defineEmits(['queryInfo']);

  const defaultTime2: [Date, Date] = [
    new Date(2000, 1, 1, 0, 0, 0),
    new Date(2000, 2, 1, 23, 59, 59)
  ];
  const deviceTypeOptions = ref([{ code: '', name: '' }]);
  const alarmRuleCodeOptions = ref([{ code: '', name: '' }]);
  const alarmLevelOptions = ref([...ALARM_LEVEL_OPTIONS].map((item) => ({
    code: item.value,
    name: item.label,
  })));
  const bizSourceOptions = ref([...BIZ_SOURCE_OPTIONS].map((item) => ({
    code: item.value,
    name: item.label,
  })));
  const processStatusOptions = ref([...PROCESS_OPTIONS].map((item) => ({
    code: item.value,
    name: item.label,
  })));
  const setDefaultDate = (type: number, alarmScope?: number | string): string => {
    let t = '';
    const date = new Date();
    const targetDate = new Date(date);

    // 当type为0时，根据alarmScope判断天数
    if (type === 0 && alarmScope !== undefined) {
      const alarmScopeValue = Number(alarmScope);
      if (alarmScopeValue === 2) {
        // 返回当天前30天
        targetDate.setDate(date.getDate() - 30);
      } else if (alarmScopeValue === 1 || alarmScopeValue === 3) {
        // 返回当天前180天
        targetDate.setDate(date.getDate() - 180);
      }
    }

    const dateMap = {
      year: targetDate.getFullYear(),
      month: targetDate.getMonth() + 1,
      day: targetDate.getDate(),
    };

    const month = dateMap.month >= 10 ? dateMap.month : `0${dateMap.month}`;
    const day = dateMap.day >= 10 ? dateMap.day : `0${dateMap.day}`;

    /*
     * type 0 默认时间 00:00:00
     * type 1 默认时间 23:59:59
     */
    t = `${dateMap.year}-${month}-${day} ${['00:00:00', '23:59:59'][type]}`;

    return t;
  };

  const timeRange:any = ref([]);
  const orgStore:any = useOrgStore();
  const loading = ref(false);
  const dialogLoading = ref(false);
  const currentOrgId = computed(() => orgStore.currentOrgInfo.orgId);
  const currentSpace = computed(() => orgStore.currentSpace);
  const statusToTxt = (status:number) => (processStatusOptions.value.find((item) => Number(item.code) === status)?.name
    || '-');
  const searchParams = reactive({
    alarmScope: 1,
    alarmSource: '',
    processStatus: '',
    bizSource: '',
    alarmLevel: [],
    deviceTypeCode: [],
    alarmRuleCode: '',
  });
  const pagination = reactive({
    pageNum: 1,
    pageSize: 20,
    total: 0,
  });
  const showIsolationModal = ref(false); // 隔离弹窗
  const isoationstatus = ref(1); // 1 隔离操作  2 隔离详情

  const title = ref('实时告警列表');
  const tableData = ref<ProjectItem[]>([]);

  // 表格最大高度自适应
  const pageMainRef = ref();
  const formRef = ref<HTMLElement>();
  const { height: pageHeight } = useElementSize(pageMainRef);
  const { height: formHeight } = useElementSize(formRef);
  const tableMaxHeight = ref('100px');
  const intervalTime = ref();
  watch(
    () => pageHeight.value,
    () => {
      tableMaxHeight.value = `${pageHeight.value - formHeight.value - 120}px`;
    },
    {
      immediate: true,
    }
  );

  const state = reactive({
    detailData: {} as any,
    currentAlarmDetailData: {} as any,
    showDetailModal: false,
  });
  const suppressionDialog = ref(false);
  const suppressionData = ref();
  const currentSuppression = ref();
  const suppressionPagination = reactive({
    pageNum: 1,
    pageSize: 20,
    total: 0,
  });

  const getQueryParams = (flag = false) => {
    const s = timeRange.value[0] || setDefaultDate(0, props.activeName);
    const e = timeRange.value[1] || setDefaultDate(1);

    let floorCodes:any = '';
    // 兼容，分页请求是get，floorCodes是字符串，导出是post，传数组
    if (orgStore.spaceValue?.length > 0) {
      if (typeof orgStore.spaceValue === 'string') {
        if (flag) {
          floorCodes = [orgStore.spaceValue];
        } else {
          floorCodes = orgStore.spaceValue;
        }
      } else if (flag) {
        floorCodes = orgStore.spaceValue;
      } else {
        floorCodes = orgStore.spaceValue.join(',');
      }
    }
    if (floorCodes === '0') {
      floorCodes = '';
    }

    const data = {
      ...searchParams,
      startTime: new Date(s).getTime(),
      endTime: new Date(e).getTime(),
      pageNum: pagination.pageNum,
      pageSize: pagination.pageSize,
      orgId: currentOrgId.value,
      floorCodes,
    };
    return data;
  };
  const viewVideoRef = ref();
  const openVideo = (item:any) => {
    console.log('item', item);
    viewVideoRef.value?.handleOpenDialog(item.spaceCode, item.deviceName);
  };
  const searchData = () => {
    if (!timeRange.value) {
      ElMessage.error('必须选择时间');
      return;
    }

    const data = getQueryParams();

    loading.value = true;
    getAlarmList(data).then((res) => {
      loading.value = false;
      if (res.code === 0) {
        tableData.value = res.data.list;
        pagination.total = res.data.total;
      }
    }).finally(() => { loading.value = false; });
  };
  const handleDetail = (data:any) => {
    state.currentAlarmDetailData = data;
    loading.value = true;
    alarmDetail({
      id: data.id,
      flag: props.activeName,
    }).then((res) => {
      if (res.code === 0) {
        loading.value = false;
        state.detailData = res.data || {};
        nextTick(() => {
          state.showDetailModal = true;
        });
      } else {
        ElMessage.error('告警数据已发送变化，请重新搜索后再查看');
      }
    }).catch().finally(() => {
      loading.value = false;
    });
  };
  const handleQuarantine = (item:any, index:number) => {
    state.currentAlarmDetailData = item;
    isoationstatus.value = index;
    showIsolationModal.value = true;
  };
  const getSuppressionData = async () => {
    const data = {
      orgId: currentSuppression.value.orgId,
      sensorId: currentSuppression.value.sensorId,
      pageNum: suppressionPagination.pageNum,
      pageSize: suppressionPagination.pageSize,
    };
    dialogLoading.value = true;
    await alarmSuppressionList(data).then((res) => {
      console.log('res', res);
      if (res.code === 0) {
        suppressionData.value = res.data.list;
        suppressionPagination.total = res.data.total;
      }
    }).catch().finally(() => { dialogLoading.value = false; });
  };
  const spHandleCurrentChange = (val = 1) => {
    suppressionPagination.pageNum = val;
    getSuppressionData();
  };
  const spHandleSizeChange = (val: number) => {
    suppressionPagination.pageNum = 1;
    suppressionPagination.pageSize = val;
    getSuppressionData();
  };
  const handleCurrentChange = (val = 1) => {
    pagination.pageNum = val;
    console.log('pagination', pagination);
    searchData();
  };
  const handleSizeChange = (val: number) => {
    pagination.pageNum = 1;
    pagination.pageSize = val;
    searchData();
  };
  const handleClick = (val:any) => {
    nextTick(() => {
      searchParams.alarmScope = val;
      title.value = TITLE_LIST[val - 1];
      handleCurrentChange(1);
    });
  };
  const handleSuppression = (item:any) => {
    currentSuppression.value = item;
    getSuppressionData();
    suppressionDialog.value = true;
  };
  const handleTimeRangeChange = () => {
    console.log('time', timeRange);
  };
  const handleReset = () => {
    timeRange.value = [
      (setDefaultDate(0, props.activeName)),
      (setDefaultDate(1))
    ];
    searchParams.processStatus = '';
    searchParams.alarmSource = '';
    searchParams.bizSource = '';
    searchParams.alarmLevel = [];
    searchParams.deviceTypeCode = [];
    searchParams.alarmRuleCode = '';
    handleClick(props.activeName);
  };
  const getAlarmFiltersData = () => {
    getAlarmFilters({
      orgId: currentOrgId.value,
      alarmScope: props.activeName,
      bizSource: searchParams.bizSource,
    }).then((res) => {
      const data = res.data;
      if (data) {
        // alarmRules alarmLevels bizSources deviceType processStatusList
        deviceTypeOptions.value = data.deviceType;
        alarmRuleCodeOptions.value = data.alarmRules;
        // 获取告警级别数据
        if (data.alarmLevels && data.alarmLevels.length > 0) {
          alarmLevelOptions.value = data.alarmLevels;
        }
        // 获取业务来源数据
        if (data.bizSources && data.bizSources.length > 0) {
          bizSourceOptions.value = data.bizSources;
        }
        // 获取工单发送状态数据
        if (data.processStatusList && data.processStatusList.length > 0) {
          processStatusOptions.value = data.processStatusList;
        }
      }
    });
  };
  const recover = (row:any) => {
    ElMessageBox.confirm(
      '解除隔离后改点位将会正常产生报警，请在点位修复后进行本操作?',
      '解除隔离',
      {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'info',
      }
    ).then(() => {
      isolateRecover({
        id: row.id,
      }).then(() => {
        ElMessage({
          type: 'success',
          message: '解除隔离成功',
          grouping: true,
        });
        searchData();
      });
    }).catch(() => {
      console.log('用户点击了取消');
    });
  };
  watch(() => props.activeName, (val) => {
    timeRange.value = [];
    handleClick(val);
  });

  const route = useRoute();
  onMounted(() => {
    console.log('alarm-list', props.activeName);
    if (props.activeName !== 1) {
      const {
        alarmTime, bizSource, alarmSource, deviceTypeCode, startData, endData, alarmLevel,
      } = route.query as any;
      if (alarmTime) {
        timeRange.value = [
          alarmTime,
          alarmTime
        ];
      } else {
        timeRange.value = [
          (setDefaultDate(0, props.activeName)),
          (setDefaultDate(1))
        ];
      }

      if (startData && endData) {
        timeRange.value = [
          `${startData} 00:00:00`,
          `${endData} 23:59:59`
        ];
      }

      if (bizSource) {
        searchParams.bizSource = bizSource as string;
      }
      if (alarmSource) {
        searchParams.alarmSource = alarmSource as string;
      }

      if (deviceTypeCode) {
        searchParams.deviceTypeCode = deviceTypeCode?.split(',');
      }
      if (alarmLevel) {
        searchParams.alarmLevel = alarmLevel?.split(',');
      }
    }

    if (props.queryParams?.bizSource || props.queryParams?.alarmLevel
      || props.queryParams?.deviceTypeCode || props.queryParams?.alarmSource) {
      Object.assign(searchParams, props.queryParams);
    }

    if (props.time.length > 0) {
      timeRange.value = props.time;
    }
    console.log('searchParams', searchParams);

    handleClick(props.activeName);
    getAlarmFiltersData();
    intervalTime.value = setInterval(() => {
      handleCurrentChange(pagination.pageNum);
    }, 20000);
  });

  onUnmounted(() => {
    console.log('destroy');
    if (intervalTime.value) {
      clearInterval(intervalTime.value);
    }
  });
  </script>

  <style lang='scss' scoped>
  :deep(.ma-tabs__content) {
    border: 0;
  }

  :deep(.ma-select__selection){
    flex-wrap: nowrap;
  }

  .sup-count{
    color: #2d8cf0;
    cursor: pointer;
  }

  :deep(.is-text){
    display: none;
  }

  .no-padding{
    padding: 0 !important;
  }
  </style>
  <style lang='scss'>
  .clear-btn{
    .is-text{
      display: none;
    }
  }
</style>
